module.exports = __webpack_public_path__ + "img/Postmodernisme_Lars-Ramslie.3a660c3c.jpg";